"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createResultProps = void 0;
var antd_1 = require("antd");
var React = __importStar(require("react"));
var constants_1 = require("../constants");
var ResultProps_1 = require("./ResultProps");
var createResultProps = function (locale, props) {
    if (!props) {
        throw new Error("You need at least one of the props defined");
    }
    var btn = null;
    var className = "iq-result no-icon " + (props.className || "");
    var extra = props.extra ? (Array.isArray(props.extra) ? props.extra : [props.extra]) : [];
    var status, myStatus, responseStatus = "", subTitle = "";
    var ErrorsStr = constants_1.ResultErrors.en;
    if (props.statusCode)
        myStatus = props.statusCode.toString();
    if (props.response && typeof props.response !== "undefined") {
        if (typeof props.response === "string") {
            if (props.response !== "") {
                myStatus = "error";
                subTitle = props.response;
            }
        }
        else {
            responseStatus = props.response.status
                ? props.response.status.toString()
                : props.statusCode
                    ? props.statusCode.toString()
                    : "customError";
            myStatus =
                ResultProps_1.ConfiguredErrors.indexOf(responseStatus) > -1
                    ? responseStatus
                    : "customErrorWithStatus";
            subTitle = props.response.statusText ? props.response.statusText : subTitle;
        }
    }
    // verify the language;
    if (locale !== "en" && constants_1.ResultErrors[locale]) {
        ErrorsStr = constants_1.ResultErrors[locale];
    }
    var title = props.title ? props.title : ErrorsStr.custom.title;
    myStatus = props.status && !props.response ? props.status : myStatus;
    subTitle = props.subTitle ? props.subTitle : subTitle;
    switch (myStatus) {
        case "400":
            title = ErrorsStr.e400.title;
            subTitle = ErrorsStr.e400.subTitle;
            btn = (React.createElement(antd_1.Button, { key: "btn1", type: "primary", onClick: function () { return window.history.back(); } }, ErrorsStr.e400.btn));
            extra = __spread([btn], extra);
            break;
        case "401":
        case "403":
            title = ErrorsStr.e403.title;
            subTitle = ErrorsStr.e403.subTitle;
            btn = (React.createElement(antd_1.Button, { key: "btn1", type: "primary", href: "/", target: "_top" }, ErrorsStr.e403.btn));
            extra = __spread([btn], extra);
            break;
        case "404": // missing the new wording
            title = ErrorsStr.e404.title;
            subTitle = ErrorsStr.e404.subTitle;
            btn = (React.createElement(antd_1.Button, { key: "btn1", type: "primary", onClick: function () { return window.history.back(); } }, ErrorsStr.e404.btn));
            extra = __spread([btn], extra);
            break;
        case "405":
        case "406":
        case "409": // missing the new wording
            title = ErrorsStr.e405.title;
            subTitle = ErrorsStr.e405.subTitle;
            break;
        case "408": // missing the new wording
            title = ErrorsStr.e408.title;
            subTitle = ErrorsStr.e408.subTitle;
            break;
        case "500":
        case "501":
        case "502":
        case "503":
        case "504":
            title = ErrorsStr.e500.title;
            subTitle = ErrorsStr.e500.subTitle;
            btn = (React.createElement(antd_1.Button, { key: "btn1", type: "primary", onClick: function () { return window.location.reload(); } }, ErrorsStr.e500.btn));
            extra = __spread([btn], extra);
            break;
        case "599":
            title = ErrorsStr.e599.title;
            subTitle = ErrorsStr.e599.subTitle;
            btn = (React.createElement(antd_1.Button, { key: "btn1", type: "primary", onClick: function () { return window.location.reload(); } }, ErrorsStr.e599.btn));
            extra = __spread([btn], extra);
            break;
        case "customErrorWithStatus":
        case "customError":
            if (responseStatus === "customErrorWithStatus" || responseStatus === "customError") {
                if (props.status)
                    status = props.status;
            }
            else {
                subTitle = subTitle + " (" + (responseStatus !== "" ? "Error " + responseStatus : "Unkown Error") + ")";
            }
            className = props.icon === null ? className + "custom-error" : className.replace("no-icon", "custom-error");
            break;
        default:
            status = props.status || myStatus;
            className = className.replace("iq-result no-icon ", "");
            return __assign(__assign({}, props), { status: status, title: title, subTitle: subTitle, className: className, extra: extra });
    }
    return __assign(__assign({}, props), { status: status, title: title, subTitle: subTitle, className: className, extra: extra });
};
exports.createResultProps = createResultProps;
//# sourceMappingURL=createResultProps.js.map